import type { ModulePermissionShape } from "@/types/permissions";

export const projectPeriodConfirmationsPermissionKeys = [
  "project_period_confirmations_confirm",
] as const;

export type ProjectPeriodConfirmationsPermissions = ModulePermissionShape<
  typeof projectPeriodConfirmationsPermissionKeys
>;
